import React from "react";
import InputDesign from "../components/InputDesign";

const Services = () => {
  return (
    <div className="flex flex-col items-center justify-start min-h-screen mb-20">
      <div className="w-full max-w-md p-4">
        <h1 className="text-2xl font-bold text-zinc-800 mb-6 text-center">
          Our Services
        </h1>
        <InputDesign />
      </div>
    </div>
  );
};

export default Services;
